module.exports = __webpack_public_path__ + "assets/img/96c4152a461563f3d3356ce9409740d9.svg";